document.addEventListener('DOMContentLoaded', () => {
  const pins = document.querySelectorAll('.scene-hotspots__pin');
  if (!pins.length) return;

  pins.forEach((pin) => {
    pin.addEventListener('click', () => {
      const item = pin.closest('.scene-hotspots__item');
      const wasActive = item.classList.contains('is-active');

      document.querySelectorAll('.scene-hotspots__item.is-active').forEach((el) => {
        if (el !== item) el.classList.remove('is-active');
      });

      item.classList.toggle('is-active', !wasActive);
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.scene-hotspots__item')) return;
    document.querySelectorAll('.scene-hotspots__item.is-active').forEach((el) => {
      el.classList.remove('is-active');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.scene-hotspots__item.is-active').forEach((el) => {
      el.classList.remove('is-active');
    });
  });
});
